export default function getAcquisitionPlaneOrientation(imageVolume) {
    const { direction } = imageVolume;
    return {
        viewPlaneNormal: direction.slice(6, 9).map((x) => -x),
        viewUp: direction.slice(3, 6).map((x) => -x),
    };
}
